module.exports = __webpack_public_path__ + "img/icon_map_4_hg_c.a3a7dcc1.png";